/**
 * Main App Component
 * Handles routing between Login and Signup pages
 */

import React, { useState } from "react";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import Login from "./components/Login";
import Signup from "./components/Signup";

// Create Material UI theme
const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#dc004e",
    },
  },
});

function App() {
  const [currentPage, setCurrentPage] = useState("signup"); // 'signup' or 'login'
  const [userEmail, setUserEmail] = useState("");

  // Handle successful signup - navigate to login with email prefilled
  const handleSignupSuccess = (email) => {
    setUserEmail(email);
    setCurrentPage("login");
  };

  // Handle successful login - you can redirect to dashboard or home page
  const handleLoginSuccess = (user, token) => {
    console.log("Login successful:", user);
    // TODO: Navigate to your dashboard/home page
    // For now, just show an alert
    alert("Login successful! Welcome to InviteHub.");
  };

  // Navigation handlers
  const navigateToLogin = () => {
    setCurrentPage("login");
  };

  const navigateToSignup = () => {
    setUserEmail("");
    setCurrentPage("signup");
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        {currentPage === "signup" ? (
          
            <Signup
              onSignupSuccess={handleSignupSuccess}
              onNavigateToLogin={navigateToLogin}
            />
          // </GoogleReCaptchaProvider>
        ) : (
          <Login
            onLoginSuccess={handleLoginSuccess}
            onNavigateToSignup={navigateToSignup}
            prefilledEmail={userEmail}
          />
        )}
      </div>
    </ThemeProvider>
  );
}

export default App;
